import ChartsPage from './ChartsPage';

export default ChartsPage;
